// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__yU2Zh","consentsList":"PatientConsents_consentsList__273bc","consentsListEmpty":"PatientConsents_consentsListEmpty__2z0Di"};